import React, { Component } from "react";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import LoadingPanel from "../../common/LoadingPanel";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { Localization } from "../../common/Localization";
import { kodFarbyCell } from "../../common/Helpers";

class SkenGrid extends Component {
    state = {
        loading: false
    };

    textArtikelCell = (props) => {
        return (
            <td onClick={() => this.onRowClick(props)}>
                <div style={{ color: "grey" }} dangerouslySetInnerHTML={{ __html: props.dataItem.cisloArtikel }}></div>
                <div style={{ fontSize: "1.4em" }} dangerouslySetInnerHTML={{ __html: props.dataItem.textArtikel }}></div>
            </td>
        );
    };

    textVelkostCell = (props) => {
        return (
            <td className="velkost-cell" onClick={() => this.onRowClick(props)}>
                <span>{props.dataItem.textVelkost} </span>
                {props.dataItem.rozdielyStav === 1 ? (
                    <span className="k-icon k-i-check" style={{ color: "green" }}></span>
                ) : (
                    <span className="k-icon k-i-x" style={{ color: "red" }}></span>
                )}
            </td>
        );
    };

    textCenaCell = (props) => {
        return (
            <td className="cena-container" onClick={() => this.onRowClick(props)}>
                <div className="cena-cell">
                    <div style={{ color: "grey" }}>{props.dataItem.textCena1 ? props.dataItem.textCena : ""}</div>
                    <div style={{ fontSize: "1.4em" }} dangerouslySetInnerHTML={{ __html: props.dataItem.textCenaZobr }}></div>
                </div>
                <div className="mena-cell">{props.dataItem.textMena}</div>
            </td>
        );
    };

    onRowClick = (e) => {
        this.props.setSelectedItem(e.dataItem.id, e.dataItem.idVariant, e.dataItem.idKarta);
    };

    renderTable(items) {
        var localizationService = provideLocalizationService(this);

        return (
            <div id="PrijemBalikaSkenGrid">
                <Grid
                    data={
                        items === null
                            ? []
                            : items.map((item) => ({
                                  ...item,
                                  selected: item.id === this.props.selectedId
                              }))
                    }
                    selectedField="selected"
                    onRowClick={this.onRowClick}
                    className="PrijemBalikaSkenovaneGrid">
                    <GridNoRecords>
                        <div className="pole-sken-norecords">
                            <Localization
                                messageKey={"PríjemBalíka.Naskenujte čiarové kódy\r\nvšetkých kusov v balíku"}
                                defaultMessage={"Naskenujte čiarové kódy\r\nvšetkých kusov v balíku"}
                            />
                        </div>
                    </GridNoRecords>
                    <GridColumn cell={this.textArtikelCell} />
                    <GridColumn cell={kodFarbyCell} width="30px" />
                    <GridColumn cell={this.textVelkostCell} width="120px" />
                    <GridColumn cell={this.textCenaCell} width="160px" />
                </Grid>
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderTable(this.props.items);

        return <div>{contents}</div>;
    }
}

export default SkenGrid;

registerForLocalization(SkenGrid);



// WEBPACK FOOTER //
// ./src/components/dialogs/PrijemBalika/SkenGrid.js